var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import { createThemeSelector, getSpacingSelector, buttonPaddingHorizontalSelector, buttonPaddingVerticalSelector } from '@signal/theme/selectors';
import Button from '../Button';
import TypographySkeleton from '../Skeleton/Typography';
export var EventTitleWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
export var EventTitle = function EventTitle(props) {
  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    variant: "body3"
  }, props));
};
export var EventContentWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var EventTimeBase = styled(Typography)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n  padding-left: ", "px;\n"])), getSpacingSelector(0.75), buttonPaddingHorizontalSelector);
export var EventTimeSkeleton = EventTimeBase.withComponent(TypographySkeleton);
export var EventTime = function EventTime(props) {
  return /*#__PURE__*/React.createElement(EventTimeBase, Object.assign({
    variant: "caption"
  }, props));
};
var EventSubtitleBase = styled(Typography)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n"])), buttonPaddingHorizontalSelector);
export var EventSubtitleSkeleton = EventSubtitleBase.withComponent(TypographySkeleton);
export var EventSubtitle = function EventSubtitle(props) {
  return /*#__PURE__*/React.createElement(EventSubtitleBase, props);
};
var subcontentHorizontalSpacingSelector = getSpacingSelector(2);
var subcontentHorizontalMarginSelector = createThemeSelector(subcontentHorizontalSpacingSelector, buttonPaddingHorizontalSelector, function (spacing, buttonPadding) {
  return spacing + buttonPadding;
});
export var EventSubcontent = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 ", "px ", "px;\n  border-left: 2px dotted ", ";\n  padding-left: ", "px;\n"])), subcontentHorizontalMarginSelector, getSpacingSelector(1.5), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grey[400];
}, subcontentHorizontalSpacingSelector);
export var EventSubcontentItem = styled(Typography)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), getSpacingSelector());
export var ExpandableWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), buttonPaddingVerticalSelector);
export var ExpandButton = styled(Button).attrs(function () {
  return {
    color: 'primary',
    size: 'small'
  };
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-top: -", "px;\n"])), buttonPaddingVerticalSelector);
export var ExpandButtonText = styled(Typography).attrs(function () {
  return {
    color: 'primary'
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([""])));